import { sendTelemetryEvent } from '../api/data-connectors/telemetry'
import { measureTrackedInsertion } from '../api/word/word-service'
import type { TrackedInsertion } from '../api/word/word-service'
import type { TelemetryTask } from '../types/telemetry'

export const INSERTION_CHECK_DELAY_MS = 10 * 60 * 1000

/**
 * Reports an Insert click right away, then comes back ten minutes later to report how much
 * of the inserted text is still in the document (the "insertion retention" metric).
 *
 * The check is a plain timer in the task pane. If the user closes the pane before it fires,
 * that insert never gets an insertion_checked event, and nothing tries to catch up later.
 */
export function reportInsertion(task: TelemetryTask, tracked: TrackedInsertion): void {
  const insertion = {
    task_id: task.taskId,
    task_type: task.taskType,
    insertion_id: crypto.randomUUID(),
  }

  sendTelemetryEvent({
    ...insertion,
    event_type: 'content_inserted',
    characters_inserted: tracked.characterCount,
  })

  setTimeout(async () => {
    try {
      const { charactersRemaining, documentCharacters } = await measureTrackedInsertion(tracked)
      sendTelemetryEvent({
        ...insertion,
        event_type: 'insertion_checked',
        characters_remaining: charactersRemaining,
        document_characters: documentCharacters,
      })
    } catch (error) {
      // Word could not measure the range (e.g. the document was closed). Send nothing
      // rather than a guessed number.
      console.warn('[Telemetry] insertion check skipped:', error)
    }
  }, INSERTION_CHECK_DELAY_MS)
}
